const VisionEcosystem = () => {
  const steps = [
    { number: "01", title: "Concept" },
    { number: "02", title: "Sourcing" },
    { number: "03", title: "Branding" },
    { number: "04", title: "Scale" },
  ];

  return (
    <section className="w-full bg-white py-20 px-6 md:px-12 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        {/*
            1. Header Section
        */}
        <div className="text-center max-w-4xl mx-auto mb-20">
          <h2 className="text-4xl md:text-5xl font-normal text-gray-900 mb-2 tracking-tight">
            You Have the Vision.
          </h2>
          <h2 className="text-4xl md:text-5xl font-normal text-[#737373] mb-8 tracking-tight">
            We Have the Ecosystem.
          </h2>

          <p className="text-[#737373] text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-12 font-medium">
            Starting a business usually means juggling multiple vendors,
            confusing legal paperwork, and shipping nightmares. We change that.
          </p>

          {/* The Promise Box */}
          <div className="bg-[#FFF5F5] border-l-4 border-[#D91F26] p-6 md:p-8 text-left max-w-2xl mx-auto rounded-r-xl">
            <h4 className="font-medium text-black mb-2 text-lg">The Promise</h4>
            <p className="text-sm md:text-base text-[#656567] leading-relaxed">
              Alldoer acts as your co-founder in operations. We don't just find
              products; we build the entire infrastructure your business needs
              to thrive from Day 1.
            </p>
          </div>
        </div>

        {/*
            2. Timeline Section
         */}
        <div className="relative mb-24 hidden md:block max-w-5xl mx-auto">
          {/* Connecting Line */}
          <div className="absolute top-[9px] left-0 w-full h-[1px] bg-red-100 z-0"></div>

          <div className="grid grid-cols-4 relative z-10">
            {steps.map((step, index) => (
              <div
                key={index}
                className="flex flex-col items-center group cursor-default"
              >
                {/* Circle Indicator */}
                <div className="w-5 h-5 rounded-full border-2 border-[#ff4d54] bg-white mb-6 transition-transform duration-300 group-hover:scale-125 shadow-sm"></div>

                {/* Number */}
                <span className="text-6xl font-light text-gray-200 mb-4 transition-colors duration-300 group-hover:text-gray-300 select-none">
                  {step.number}
                </span>

                {/* Title */}
                <span className="text-xl lg:text-3xl font-normal text-gray-900">
                  {step.title}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile View for Steps */}
        <div className="grid grid-cols-2 gap-8 md:hidden mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-xl"
            >
              <span className="text-4xl font-light text-gray-200 mb-2">
                {step.number}
              </span>
              <span className="text-lg font-medium text-gray-900">
                {step.title}
              </span>
            </div>
          ))}
        </div>

        {/* 
            3. Image Grid 
         */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {/* Column 1: Two Stacked Images */}
          <div className="flex flex-col gap-6 h-[600px] md:h-[700px]">
            <div className="relative h-1/2 overflow-hidden rounded-3xl">
              <img
                src="./images/man5.png"
                alt="Concept phase"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="relative h-1/2 overflow-hidden rounded-3xl">
              <img
                src="./images/man1.png"
                alt="Mobile work"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>

          {/* Column 2: One Tall Image*/}
          <div className="relative h-[400px] md:h-full overflow-hidden rounded-3xl">
            <img
              src="./images/man2.png"
              alt="Visionary VR"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>

          {/* Column 3: Two Stacked Images */}
          <div className="flex flex-col gap-6 h-[600px] md:h-[700px]">
            <div className="relative h-1/2 overflow-hidden rounded-3xl">
              <img
                src="./images/man4.png"
                alt="Scaling business"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="relative h-1/2 overflow-hidden rounded-3xl">
              <img
                src="./images/man3.png"
                alt="Team meeting"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionEcosystem;
